export const DefaultUnitFormat: Readonly<Intl.NumberFormatOptions> = {
  style: 'unit',
};
